import { HttpClient } from '../utils/httpClient';

const PATH = {
    events: '/root/bess/events',
    currentEvents: '/root/bess/current-events',
    overviewEvents: '/root/bess/overview-events',
    logs: '/root/bess/event-logs',
    commandLogs: '/root/bess/command-logs',
    dataLog: '/root/bess/data-log'
};

const GetEvents = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.events}`, { params }).then(callback).catch(error).finally(next);
};

const GetCurrentEvents = (start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.currentEvents}`).then(callback).catch(error).finally(next);
};

const GetOverviewEvents = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.overviewEvents}`, { params }).then(callback).catch(error).finally(next);
};

const GetLogs = (id, params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.logs}/${id}`, { params }).then(callback).catch(error).finally(next);
};

const GetCommandLogs = (id, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.commandLogs}/${id}`).then(callback).catch(error).finally(next);
};

const GetDataLog = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.dataLog}`, { params }).then(callback).catch(error).finally(next);
};

export const EventsService = {
    GetEvents,
    GetCurrentEvents,
    GetOverviewEvents,
    GetLogs,
    GetCommandLogs,
    GetDataLog
};
